// extracted by css-extract-rspack-plugin
export default {"inline":"kQnbe","root":"oFiLy"};